import React from 'react';
import { Baby, Search, Clock, Frown, Moon, HelpCircle } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ProblemSection() {
  const painPoints = [{
    icon: Baby,
    text: 'Tu bebé llora y no sabés si tiene hambre, sueño o dolor'
  }, {
    icon: Search,
    text: 'Googleás todo a las 3 de la mañana buscando respuestas'
  }, {
    icon: Clock,
    text: 'Cada día es distinto y no tenés ninguna rutina'
  }, {
    icon: Frown,
    text: 'Los berrinches te hacen sentir que estás fallando'
  }, {
    icon: Moon,
    text: 'Terminás el día agotada sin saber si lo hiciste bien'
  }, {
    icon: HelpCircle,
    text: 'Todos opinan pero nadie te da una guía clara'
  }];
  return <section className="bg-white py-24 px-6" data-id="element-185">
      <div className="max-w-4xl mx-auto" data-id="element-186">
        <div className="text-center mb-16" data-id="element-187">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-brand-black mb-6" data-id="element-188">
            ¿Te suena familiar?
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-189">
          {painPoints.map((point, index) => <div key={index} className="bg-brand-cream rounded-2xl p-6 flex flex-col items-center text-center hover:-translate-y-1 transition-transform duration-300 shadow-sm hover:shadow-md" data-id="element-190">
              <div className="w-12 h-12 bg-brand-sage/10 rounded-full flex items-center justify-center mb-4 text-brand-sage" data-id="element-191">
                <point.icon className="w-6 h-6" data-id="element-192" />
              </div>
              <p className="font-medium text-brand-charcoal" data-id="element-193">{point.text}</p>
            </div>)}
        </div>

        <div className="bg-brand-sage text-white rounded-3xl p-8 md:p-12 text-center shadow-lg relative overflow-hidden mb-12" data-id="element-194">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/3 blur-2xl" data-id="element-195"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-brand-black/10 rounded-full translate-y-1/3 -translate-x-1/3 blur-2xl" data-id="element-196"></div>

          <div className="relative z-10 space-y-6" data-id="element-197">
            <p className="text-2xl md:text-3xl font-serif" data-id="element-198">
              Y lo peor no es el cansancio.
            </p>
            <p className="text-xl md:text-2xl font-medium" data-id="element-199">
              Es la culpa de no saber si lo estás haciendo bien.
            </p>
            <p className="text-lg text-white/80" data-id="element-200">
              Es sentir que todas las demás mamás saben algo que vos no.
            </p>
            <div className="inline-block bg-white/20 px-6 py-3 rounded-full backdrop-blur-sm mt-4" data-id="element-201">
              <p className="text-xl font-bold" data-id="element-202">
                Pero no es tu culpa. Nadie te preparó para esto.
              </p>
            </div>
          </div>
        </div>

        <div className="text-center" data-id="element-203">
          <CTAButton text="QUIERO TENER CLARIDAD" data-id="element-204" />
          <p className="text-sm text-brand-red font-bold mt-3" data-id="element-205">
            Todo por solo $19.990 — Oferta por tiempo limitado
          </p>
        </div>
      </div>
    </section>;
}